import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { MongoDbCopySource } from 'app/model/pipeline/copysource/mongo-db.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MongoDbCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class MongoDbCopySourceAdapter extends CopySourceAdapter<MongoDbCopySource, Model.MongoDbSource> {
    protected override async _toResource(copySource: MongoDbCopySource): Promise<Model.MongoDbSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(MongoDbCopySource).name);
    }

    protected override async _toModel(
        resource: Model.MongoDbSource,
        copyActivity: CopyActivity
    ): Promise<MongoDbCopySource> {
        return this._toTabularModel(resource, copyActivity, MongoDbCopySource.MODEL);
    }
}
